//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default{
  data:()=>({
    show: false
  }),
  computed:{
    filled(){
      if ( !this.show && this.value ) {
        return 'has__content'
      }
      return ''
    },
    has__icon(){
      if ( this.icon ){
        return 'input__has__icon'
      }
      return
    },
    focus__border(){
      return {
        "background-color" : this.color
      }
    }
  },
  props: {
    value : { type: String , required: false, default: ''},
    label: { type: String , required: false, default: ''},
    hint: { type: String, required:false , default:''},
    icon: { type: String, required: false , default: '' },
    placeholder: { type: String, required: false, default: ''},
    color: { type: String , required: false , default: '' },
    disabled:{type: Boolean , required: false , default: false}
  },
}
